import React, { memo, useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import $ from "jquery";

import Pagination from "../Pagination/Pagination";
import Loader from "../resuableComponent/loader";
import EditTaskPopup from "./EditTaskPopup";
import RemediationActionButton from "../common/RemediationActionButton";

import { getOverviewList, removeTicket } from "../../actions/remediationMode";

const RemediationTicket = () => {
  const dispatch = useDispatch();
  const [category, setCategory] = useState("all");
  const auth = useSelector((state) => state?.auth?.user);
  const id = useSelector((state) => {
    return (
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
    );
  });
  const list = useSelector((state) => {
    return state?.remediationMode?.list?.data;
  });
  const pagination = useSelector(
    (state) => state?.remediationMode?.list?.data?.pagination
  );
  const totalItems = useMemo(() => {
    return pagination?.total || 1;
  }, [pagination?.total]);
  const [page, setPage] = useState(1);
  // const [totalItems, setTotalItems] = useState(1);
  const [containerClass, setContainerClass] = useState("data-container");
  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  useEffect(() => {
    getOverviewList(id, dispatch, page, "ticket", category);
  }, [category, dispatch, id, page]);

  useEffect(() => {
    if (list?.tickets) {
      setTimeout(() => {
        setContainerClass("data-container active");
      }, 300);
    }
  }, [list?.tickets]);

  const removeRemediationData = (recordId) => (e) => {
    $.confirm({
      title: "Are you sure?",
      content:
        "Do you really want to remove this from the Remediation List Panel?",
      type: "red",
      buttons: {
        ok: {
          text: "Remove",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            removeTicket(recordId, id, dispatch, "ticket", category);
          },
        },
        cancel: function () {},
      },
    });
  };

  return (
    <div>
      {list ? (
        <div className={containerClass}>
          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9" style={{ padding: "0" }}>
              <div className="row_boxes row_boxes_table">
                {/* Tab Navigation */}
                <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
                  <li className="nav-item">
                    <span
                      className={`nav-table-tab nav-link ${
                        category === "all" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("all");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "ticket", "");
                      }}
                    >
                      Overview
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "InProgress" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("InProgress");
                        setPage(1);
                        getOverviewList(
                          id,
                          dispatch,
                          1,
                          "ticket",
                          "InProgress"
                        );
                      }}
                    >
                      In Process
                    </span>
                  </li>
                  <li className="nav-item">
                    <span
                      className={`nav-link nav-table-tab ${
                        category === "Close" ? "active" : ""
                      }`}
                      onClick={() => {
                        setCategory("Close");
                        setPage(1);
                        getOverviewList(id, dispatch, 1, "ticket", "Close");
                      }}
                    >
                      Completed
                    </span>
                  </li>
                </ul>
                <div className="table_box">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>
                          {auth?.accessLevel != "Threat Analyst" &&
                            (category === "all" ||
                              category === "risk-accepted" ||
                              category === "false-positive") && (
                              <input
                                type="checkbox"
                                checked={
                                  selectedIds == 0 ? false : multiCheckTrue
                                }
                                onClick={() => {
                                  // multicheck(currentTableData);
                                }}
                                className="checkUncheck"
                              />
                            )}
                        </th>
                        <th>Date Added</th>
                        <th>Task Id</th>
                        <th>Type</th>
                        <th>Details</th>
                        <th>Notes</th>
                        <th>Rating</th>
                        <th>Priority</th>
                        <th>Status</th>
                        <th>Training Requested</th>
                        <th>Due Date</th>
                        <th>Last Updated</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {list?.tickets?.map((r) => {
                        return (
                          <>
                            <tr>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedIds == 0 ? false : multiCheckTrue
                                  }
                                  onClick={() => {
                                    // multicheck(currentTableData);
                                  }}
                                  className="checkUncheck"
                                />
                              </td>
                              <td>
                                {r?.createdAt
                                  ? moment(r?.createdAt).format("DD-MM-YYYY")
                                  : "NA"}
                              </td>
                              <td>{r?.taskId || "N/A"}</td>
                              {/* <td>{r?.actionType || "N/A"}</td> */}
                              <td>
                                {r?.findingDetails?.specificInfo || "N/A"}
                              </td>
                              <td>{r?.findingDetails?.detail || "N/A"}</td>
                              <td>{r?.note || "N/A"}</td>
                              <td>{r?.rating || "N/A"}</td>
                              <td>{r?.priority || "N/A"}</td>
                              <td
                                style={{
                                  textTransform: "uppercase",
                                  color: r?.status
                                    ? r?.status === "Open"
                                      ? "#28a745"
                                      : r?.status === "InProgress"
                                      ? "#ffc107"
                                      : r?.status === "Close"
                                      ? "#6c757d"
                                      : "#000000"
                                    : "#000000",
                                }}
                              >
                                {(r?.status === "InProgress"
                                  ? "In Progress"
                                  : r?.status) || "N/A"}
                              </td>
                              <td>{r?.trainingRequested || "Not found"}</td>
                              <td
                                style={{
                                  color: r?.dueDate
                                    ? moment(r?.dueDate).isBefore(
                                        moment(),
                                        "day"
                                      )
                                      ? "red"
                                      : moment(r?.dueDate).isBefore(
                                          moment().add(7, "days"),
                                          "day"
                                        )
                                      ? "yellow"
                                      : "white"
                                    : "white",
                                }}
                              >
                                {r?.dueDate
                                  ? moment(r?.dueDate).format("DD-MM-YYYY")
                                  : "N/A"}
                              </td>
                              <td>
                                {r?.updatedAt
                                  ? moment(r?.updatedAt).format("DD-MM-YYYY")
                                  : "N/A"}
                              </td>
                              <td>
                                <span
                                  className="openTask"
                                  onClick={() => {
                                    setSelectedTicket(r);
                                    setIsPopupOpen(true);
                                  }}
                                >
                                  Open Task
                                </span>
                              </td>
                              <RemediationActionButton
                                onRemove={() =>
                                  removeRemediationData(r?.recordId)
                                }
                                shouldShowPlus={false}
                              />
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="dataTables_paginate">
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={10}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
      {isPopupOpen && (
        <EditTaskPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          taskData={selectedTicket}
        />
      )}
    </div>
  );
};

export default memo(RemediationTicket);
